'use strict';

module.exports = require('./InputNumber');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-input-number/lib/index.js
 ** module id = 351
 ** module chunks = 0
 **/